import { useEffect, useState, useCallback } from 'react'

export interface TelegramUser {
  id: number
  firstName: string
  lastName?: string
  username?: string
  languageCode?: string
  isPremium?: boolean
}

export interface UseTelegramReturn {
  user: TelegramUser | null
  isReady: boolean
  isTelegram: boolean
  impactOccurred: (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => void
  notificationOccurred: (type: 'error' | 'success' | 'warning') => void
  expand: () => void
}

export function useTelegram(): UseTelegramReturn {
  const [isReady, setIsReady] = useState(false)
  const [user, setUser] = useState<TelegramUser | null>(null)
  
  const isTelegram = typeof window !== 'undefined' && !!window.Telegram?.WebApp

  useEffect(() => {
    if (isTelegram && window.Telegram?.WebApp) {
      const webApp = window.Telegram.WebApp
      webApp.ready?.()
      webApp.expand?.()
      
      const tgUser = webApp.initDataUnsafe?.user
      if (tgUser) {
        setUser({
          id: tgUser.id,
          firstName: tgUser.first_name,
          lastName: tgUser.last_name,
          username: tgUser.username,
          languageCode: tgUser.language_code,
          isPremium: tgUser.is_premium,
        })
      }
      setIsReady(true)
    } else {
      setIsReady(true)
    }
  }, [isTelegram])

  const impactOccurred = useCallback((style: string) => {
    window.Telegram?.WebApp?.HapticFeedback?.impactOccurred?.(style)
  }, [])

  const notificationOccurred = useCallback((type: string) => {
    window.Telegram?.WebApp?.HapticFeedback?.notificationOccurred?.(type)
  }, [])

  const expand = useCallback(() => {
    window.Telegram?.WebApp?.expand?.()
  }, [])

  return {
    user,
    isReady,
    isTelegram,
    impactOccurred,
    notificationOccurred,
    expand,
  }
}
